import ExternalUser from 'modules/user-management/external-user';

export default function ExternalUserPage() {
  return <ExternalUser />;
}
